const UPDATE_WORKFLOW_TYPES = {
  UPDATE_FLOW_NAME: 'UPDATE_FLOW_NAME',
  TOGGLE_WORKFLOW_ON: 'TOGGLE_WORKFLOW_ON',
  TOGGLE_WORKFLOW_OFF: 'TOGGLE_WORKFLOW_OFF'
};
export default UPDATE_WORKFLOW_TYPES;